import React from 'react';
import AcastLogo from '../ui/Logo';
import PropTypes from 'prop-types';
import { Layout, Row } from 'antd';
import config from '../../config';
import Loader from '../ui/Loader';

function PublicLayout({ children, loading }) {
  return (
    <Layout>
      <Layout.Header>
        <Row align="middle" justify="center">
          <a href={config.corporateUrl}>
            <span>
              <AcastLogo />
            </span>
          </a>
        </Row>
      </Layout.Header>
      <Layout.Content>
        <Row align="middle" justify="center" className="main">
          {loading ? <Loader /> : <div className="body">{children}</div>}
        </Row>
      </Layout.Content>
    </Layout>
  );
}

PublicLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  loading: PropTypes.bool,
};

export default PublicLayout;
